export enum FlightSearchTrackingRawEventName {
  ChangedTripType = "ChangedTripType",
  ViewedCalendar = "ViewedCalendar",
  ChangedCalendarDate = "ChangedCalendarDate",
  ViewedAirSearch = "ViewedAirSearch",
}
